import { useRequestMedicalContext } from "../../Contexts/RequestMedicalTestContext";
import CustomizedProgressBar from "../../Components/LinearDeterminate";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { baseUrl } from "../../utilities/configurations";
import BookingResultsModal from "./BookingResultsModal";
import { ScrollBar } from "../../Components/ScrollBar";
import { useAuth } from "../../Contexts/AuthContext";
import Button from "../../Components/Button";
import { useRef } from "react";
import dayjs from "dayjs";
import axios from "axios";
import {
  ExpandMoreOutlined,
  KeyboardArrowLeft,
  CloseOutlined,
} from "@mui/icons-material";
import {
  AccordionDetails,
  AccordionSummary,
  Typography,
  Accordion,
} from "@mui/material";

function ReqMedical6() {
  const submissionInProgress = useRef(false);
  const { token } = useAuth();
  const {
    setDisplaySummaryAlert,
    selectedProcedureClass,
    selectedProcedures,
    setDisplayAlert,
    selectedPolicy,
    selectedClinic,
    compileToPDF,
    setIsLoading,
    handleBack,
    setSummary,
    isLoading,
    files,
    url,
  } = useRequestMedicalContext();

  const handleNext = async () => {
    if (submissionInProgress.current) return;
    if (files.length === 0) {
      setIsLoading(true);
      submissionInProgress.current = true;
      const results = await Promise.allSettled(
        selectedProcedures.map(async (data) => {
          const formData = new FormData();
          formData.append("DateTime", data.time);
          formData.append("ProviderId", data.id);
          formData.append("CalendarId", data.calendarId);
          formData.append(
            "Notes",
            data.coveredProcedures.map((procedure) => procedure.name).join(", ")
          );
          formData.append(
            "IsLaboratory",
            data.name.substring(data.name.indexOf(":") + 1).trim() ===
              "LABORATORY PROCEDURES"
          );
          formData.append(
            "OrdersDetails",
            JSON.stringify(
              data.coveredProcedures.map((procedure) => ({
                id: Number(procedure.orderId),
                Procedures: [procedure.name],
              }))
            )
          );
          formData.append("CardNo", selectedPolicy.cardNo);
          formData.append("CorpCode", selectedPolicy.corpCode);
          if (
            data.name.substring(data.name.indexOf(":") + 1).trim() ===
            "ULTRASOUND PROCEDURES"
          ) {
            data.coveredProcedures.forEach((procedure) => {
              formData.append("CptCodes", procedure.cptCode);
            });
          }
          if (
            data.name.substring(data.name.indexOf(":") + 1).trim() ===
            "ULTRASOUND PROCEDURES"
          ) {
            formData.append(
              "SpecificProcedureName",
              data.coveredProcedures[0].name
            );
          } else {
            formData.append("SpecificProcedureName", "");
          }

          try {
            const response = await axios.post(
              `${baseUrl}/medical-test/appointment`,
              formData,
              {
                headers: {
                  Authorization: `Bearer ${token.accessToken}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            return response.data;
          } catch (error) {
            console.log(error);
            return error;
          }
        })
      );

      // Compile the results into a single summary string
      let summaryArray = [];
      results.forEach((result, index) => {
        const procedureName = selectedProcedures[index].name.substring(
          selectedProcedures[index].name.indexOf(":") + 1
        );
        if (result.status === "fulfilled") {
          summaryArray.push({
            procedure: procedureName,
            data: selectedProcedures[index],
            message: result.value, // Access the response data correctly
          });
        } else {
          summaryArray.push({
            procedure: procedureName,
            data: selectedProcedures[index],
            message: result.reason || "An error occurred", // Handle the error case
          });
        }
      });

      // Update the summary state
      await setSummary(summaryArray);
      setIsLoading(false);
      submissionInProgress.current = false;
      setDisplaySummaryAlert(true);
    } else {
      setIsLoading(true);
      submissionInProgress.current = true;
      await compileToPDF;
      const results = await Promise.allSettled(
        selectedProcedureClass.map(async (data) => {
          const formData = new FormData();
          formData.append("DateTime", data.time);
          formData.append("ProviderId", data.id);
          formData.append("CalendarId", data.calendarId);
          formData.append("Notes", "");
          formData.append("Order", url);
          formData.append(
            "IsLaboratory",
            data.name.substring(data.name.indexOf(":") + 1).trim() ===
              "LABORATORY PROCEDURES"
          );
          formData.append("CardNo", selectedPolicy.cardNo);
          formData.append("CorpCode", selectedPolicy.corpCode);
          if (
            data.name.substring(data.name.indexOf(":") + 1).trim() !==
            "ULTRASOUND PROCEDURES"
          ) {
            formData.append("SpecificProcedureName", "");
          }

          try {
            const response = await axios.post(
              `${baseUrl}/medical-test/appointment`,
              formData,
              {
                headers: {
                  Authorization: `Bearer ${token.accessToken}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            return response.data;
          } catch (error) {
            console.log(error);
            return error;
          }
        })
      );

      // Compile the results into a single summary string

      let summaryArray = [];
      results.forEach((result, index) => {
        const procedureName = selectedProcedureClass[index].name.substring(
          selectedProcedureClass[index].name.indexOf(":") + 1
        );
        if (result.status === "fulfilled") {
          summaryArray.push({
            procedure: procedureName,
            data: selectedProcedureClass[index],
            message: result.value, // Access the response data correctly
          });
        } else {
          summaryArray.push({
            procedure: procedureName,
            data: selectedProcedureClass[index],
            message: result.reason || "An error occurred", // Handle the error case
          });
        }
      });

      // Update the summary state
      await setSummary(summaryArray);
      setIsLoading(false);
      submissionInProgress.current = false;
      setDisplaySummaryAlert(true);
    }
  };

  let content = null;
  if (files.length > 0) {
    content = selectedProcedureClass.map((data) => (
      <Accordion defaultExpanded key={data}>
        <AccordionSummary
          expandIcon={<ExpandMoreOutlined />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography>
            {data.name ? data.name.substring(data.name.indexOf(":") + 1) : null}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className="text-sm text-[#60656D]">Date</div>
          <div className="">
            {data.date ? dayjs(data.date).format("MMMM DD, YYYY") : null}
          </div>
          <div className="text-sm text-[#60656D]">Time</div>
          <div className="">
            {data.time
              ? `${dayjs(data.time).format("h:mm")} ${
                  dayjs(data.time).hour() < 12 ? "AM" : "PM"
                }`
              : null}
          </div>
          <div className="text-sm text-[#60656D]">Diagnostic Order</div>
          <div className="">{files.length > 0 ? "thru file upload" : ""}</div>
          <div className="text-sm text-[#60656D]">Preparation</div>
          <div className="">
            <p>
              An email will be sent containing the preparation instructions (if
              applicable).
            </p>
          </div>
        </AccordionDetails>
      </Accordion>
    ));
  } else {
    content = selectedProcedures.map((data) => (
      <Accordion defaultExpanded key={data}>
        <AccordionSummary
          expandIcon={<ExpandMoreOutlined />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography>
            {data.name ? data.name.substring(data.name.indexOf(":") + 1) : null}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className="text-sm text-[#60656D]">Date</div>
          <div className="">
            {data.date ? dayjs(data.date).format("MMMM DD, YYYY") : null}
          </div>
          <div className="text-sm text-[#60656D]">Time</div>
          <div className="">
            {data.time
              ? `${dayjs(data.time).format("h:mm")} ${
                  dayjs(data.time).hour() < 12 ? "AM" : "PM"
                }`
              : null}
          </div>
          <div className="text-sm text-[#60656D]">Diagnostic Order</div>
          <div className="">
            {data.coveredProcedures
              ? data.coveredProcedures.length > 0
                ? data.coveredProcedures.map((proc) => `${proc.name},`)
                : null
              : null}
          </div>
          <div className="text-sm text-[#60656D]">Preparation</div>
          <div className="">
            <p>
              An email will be sent containing the preparation instructions (if
              applicable).
            </p>
          </div>
        </AccordionDetails>
      </Accordion>
    ));
  }

  return (
    <div className="flex flex-col min-h-screen sm:items-center sm:bg-[#E7EEFA]">
      <div className="flex flex-col flex-1 sm:flex-none bg-white sm:w-148 sm:items-center rounded-xl sm:my-24">
        <div className="w-full">
          <div className="flex flex-row p-3">
            <KeyboardArrowLeft
              className="cursor-pointer"
              onClick={handleBack}
            />
            <div className="text-center text-md font-bold flex-1">
              Request Medical Test
            </div>
            <CloseOutlined
              className=" cursor-pointer"
              onClick={() => setDisplayAlert(true)}
            />
          </div>
          <div className="p-3">
            <CustomizedProgressBar value={86.02} />
          </div>
        </div>

        <div className="w-full px-3">
          <div className="font-bold">Booking Summary</div>
          <div className="text-[#60656D]">
            Review and confirm your appointment details
          </div>
          <div className="w-full bg-[#F6F7F7] mt-3 p-3 rounded-xl">
            <div className="s">
              <div className="font-bold">{selectedClinic?.providerName}</div>
              <div>{selectedClinic?.address}</div>
            </div>
          </div>
          <ScrollArea.Root className="w-full">
            <ScrollArea.Viewport className="w-full min-h-[200px] h-[calc(100vh-224px)] sm:h-full rounded">
              {content}
            </ScrollArea.Viewport>
            <ScrollBar />
          </ScrollArea.Root>
        </div>

        <div className="flex w-full p-4 mt-auto sm:justify-end">
          <Button
            disabled={isLoading}
            className={`h-14 w-full sm:w-22.5 rounded-xl ${
              isLoading ? "bg-[#F6F7F7]" : "bg-[#0053CC]"
            }`}
            onClick={handleNext}
          >
            <p
              className={`font-medium font-sans text-xs ${
                isLoading ? "text-[#A3A7AB]" : "text-white"
              }`}
            >
              Submit
            </p>
          </Button>
        </div>
      </div>
      <BookingResultsModal />
    </div>
  );
}

export default ReqMedical6;
